import React, { Component } from 'react';
import PropTypes from 'prop-types';

import WebsiteRow from './WebsiteRow';
import AddableRow from '../AddableRow';

class WebsitesList extends Component {
	constructor (props) {
		super(props);

		this.state = {
			list: props.list || []
		}
	}

	componentWillReceiveProps (nextProps) {
		if (nextProps.list && nextProps.list !== this.state.list) {
			this.setState({
				list: nextProps.list
			});
		}
	}

	handleItemChange = (value, index) => {
		const { list } = this.state;
		list[index] = value;
		this.setState({
			list
		}, this.updateState);
	}

	addRow = () => {
		this.setState(prevState => ({
			list: [...prevState.list, '']
		}), this.updateState);
	}

	removeRow = index => {
		const { list } = this.state;
		list.splice(index, 1);
		this.setState({
			list
		}, this.updateState);
	}

	updateState = () => {
		this.props.updateState(this.state.list, 'websites');
	}

	render () {
		const { isEditMode } = this.props;
		const { list } = this.state;

		return (
			<div className="websites-list">
				{
					list.map((row, key) => <AddableRow key={key} rowKey={key} onRemove={this.removeRow}>
						<WebsiteRow rowData={row} isEditMode={isEditMode} rowKey={key} onChange={this.handleItemChange} />
					</AddableRow>)
				}

				<div className="add-row-button" onClick={this.addRow}>
					<i className="fi flaticon-add"></i>
					<span className="description">Добавить сайт</span>
				</div>
			</div>
		)
	}
}

WebsitesList.propTypes = {
	isEditMode: PropTypes.bool,
	list: PropTypes.array,
	updateState: PropTypes.func
}

export default WebsitesList;



// WEBPACK FOOTER //
// ./components/ClientForm/Websites/WebsitesList.js